import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useShiftActions } from 'modules/attendance/hooks/shifts/useShiftActions'

import ShiftLocationForm from './ShiftLocationForm'

class ShiftForm extends Form {
  constructor(values: Record<string, string | number>) {
    super(values, {
      locationType: 'string',
      id: 'string',
    })
  }
}

interface Props {
  shifts: TimesheetPageShiftFragment[]
  onClose: (...args: TimesheetPageShiftFragment[]) => void
  date: moment.Moment
}

const AddLocationsModal = ({ shifts, onClose, date }: Props) => {
  const day = date.format('Do')
  const month = date.format('MMMM')

  const [forms, setForm] = React.useState(
    shifts.map(
      (shift) =>
        new ShiftForm({
          locationType: shift.locationType || '',
          id: shift.id,
        })
    )
  )
  const { updateShift } = useShiftActions()

  const { running: submitting, performAction: onSubmit } = useAsyncAction(
    async (closePortal: () => void) => {
      try {
        app.setProgress({
          message: i18n.t('common.saving'),
        })
        await Promise.all(
          forms
            .filter((form) => form.isDirty)
            .map((form: ShiftForm) => {
              const formValues = form.data()
              const id = String(form.get('id').value)
              const shift = shifts.find((shiftValue) => shiftValue.id === id)
              const locationType = formValues?.locationType

              return form.handleErrors(() => {
                if (shift) {
                  return updateShift({
                    id: formValues?.id,
                    locationType,
                    date: shift.referenceDate,
                    fetchDependencies: false,
                  })
                }
                return Promise.resolve(null)
              })
            })
        )
        setForm(forms)
        closePortal()
      } finally {
        app.setProgress(null)
      }
    }
  )

  return (
    <Modal
      illustration="location-pin-add"
      title={i18n.t('clock_in.locations.modal.title')}
      description={i18n.t('clock_in.locations.modal.description', {
        day,
        month,
      })}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={submitting} submit>
          {i18n.t('clock_in.locations.edit.title')}
        </Button>
      }
    >
      <Box gap="s16">
        {forms.map((form) => (
          <ShiftLocationForm key={form.get('id').value} form={form} shifts={shifts} />
        ))}
      </Box>
    </Modal>
  )
}

export default observer(AddLocationsModal)
